import { isValidJSON } from '../../utils/validations'

export const intentJsonValidation = (intentName, model) => {
  let isValid = true
  if (model.type === 'JSON') {
    isValid = isValidJSON(model.name)
  }
  return isValid
}

export const intentFlowValidation = (intentName, model) => {
  let isValid = true
  if (model.type === 'FLOW' && isValidJSON(model.name)) {
    isValid = !!JSON.parse(model.name).name
  }
  return isValid
}
